export default __webpack_public_path__ + "static/media/malik_body.6722193f.png";